import { useQuery } from '@tanstack/react-query';
import type { FrontendModule } from '@aurora/module-sdk/web';

import { api } from '../api/client.js';
import type { ModulesResponse, ModuleState } from '../api/types.js';
import { useTenantSlug } from '../state/tenant.js';
import { loadFrontendModules } from './registry.js';

export interface ModulesData {
  /** Zustand aller Module (fürs Verwaltungs-UI). */
  states: ModuleState[];
  /** Geladene Frontend-Module (nur aktivierte, nur mit Frontend-Teil). */
  frontendModules: FrontendModule[];
}

export function useModules() {
  const tenantSlug = useTenantSlug();
  return useQuery<ModulesData>({
    queryKey: ['modules', tenantSlug],
    enabled: tenantSlug !== null,
    staleTime: 30_000,
    queryFn: async () => {
      const { modules } = await api<ModulesResponse>('/api/v1/modules');
      const enabledNames = modules
        .filter((module) => module.enabledForTenant)
        .map((module) => module.name);
      const frontendModules = await loadFrontendModules(enabledNames);
      return { states: modules, frontendModules };
    },
  });
}
